import { logger } from '@/lib/logger'
import { FlashSaleResponse } from '@/types/flash-sale'
import { FlashSaleFormatter } from '../formatter/__f.flash-sale'
import { httpClient } from './http-client'

export const __cFlashSaleService = {
  async getFlashSales() {
    try {
      const response = await httpClient.V3.get<FlashSaleResponse>(
        '/flash-sales/list-items'
      )

      return FlashSaleFormatter.reformatFlashSale(response)
    } catch (error) {
      logger.error('error', error)
      return {
        current: null,
        next: null,
        countDownTime: null,
      }
    }
  },

  // Danh sách gốc, chưa lọc/giới hạn — dùng khi cần lọc theo chương trình
  async getFlashSaleList() {
    try {
      return await httpClient.V3.get<FlashSaleResponse>(
        '/flash-sales/list-items'
      )
    } catch (error) {
      logger.error('error', error)
      return []
    }
  },
}
